module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.active) ? _c('div', {
    staticClass: "notification is-info text-align-left p-3",
    class: {
      dismissed: _vm.notification.dismissed
    }
  }, [_c('div', {
    staticClass: "d-flex justify-space-between"
  }, [_c('UpdatingTime', {
    staticClass: "bold",
    attrs: {
      "time": _vm.created_on
    }
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.notification.dismissed),
      expression: "!notification.dismissed"
    }],
    staticClass: "delete",
    attrs: {
      "disabled": _vm.dismissing
    },
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-space-between"
  }, [(_vm.ntype == 'col_connected') ? _c('p', [_vm._v("You're now connected with " + _vm._s(_vm.notification.user.name || _vm.notification.user.email))]) : (_vm.ntype == 'col_request_rec') ? _c('div', [_c('p', {
    staticClass: "mb-1"
  }, [_vm._v(_vm._s(_vm.notification.user.name || _vm.notification.user.email) + " wants to connect with you")]), _vm._v(" "), _c('button', {
    staticClass: "button is-small is-primary is-outlined",
    class: {
      'is-inverted': !_vm.notification.dismissed
    },
    on: {
      "click": function($event) {
        _vm.accept(_vm.notification.user.id)
      }
    }
  }, [_vm._v("Accept")]), _vm._v(" "), _c('button', {
    staticClass: "button is-small is-danger is-outlined",
    class: {
      'is-inverted': !_vm.notification.dismissed
    },
    on: {
      "click": function($event) {
        _vm.deny(_vm.notification.user.id)
      }
    }
  }, [_vm._v("Deny")])]) : (_vm.ntype == 'col_request_sent') ? _c('p', [_vm._v("\n        You sent a connection request to " + _vm._s(_vm.notification.user.name || _vm.notification.user.email) + "\n      ")]) : (_vm.ntype === 'group_applied') ? _c('p', [(_vm.notification.text) ? _c('span', [_vm._v("\n          You requested to join the group "), _c('b', [_vm._v(_vm._s(_vm.notification.text))])]) : _c('span', [_vm._v("\n          You requested to join an "), _c('em', [_vm._v("unnamed")]), _vm._v(" group.\n        ")])]) : (_vm.ntype === 'group_joined') ? _c('p', [(_vm.notification.text) ? _c('span', [_vm._v("\n          You successfully joined the group "), _c('b', [_vm._v(_vm._s(_vm.notification.text))])]) : _c('span', [_vm._v("\n          You successfully joined an "), _c('em', [_vm._v("unnamed")]), _vm._v(" group.\n        ")])]) : (_vm.ntype === 'group_left') ? _c('p', [(_vm.notification.text) ? _c('span', [_vm._v("\n          You left the group "), _c('b', [_vm._v(_vm._s(_vm.notification.text))])]) : _c('span', [_vm._v("\n          You successfully left an "), _c('em', [_vm._v("unnamed")]), _vm._v(" group.\n        ")])]) : (_vm.ntype == 'vid_shared') ? _c('p', [_vm._v("\n        " + _vm._s(_vm.notification.user.name || _vm.notification.user.email) + " shared a "), _c('router-link', {
    attrs: {
      "to": '/videos/' + _vm.notification.video.id
    }
  }, [_vm._v("video")]), _vm._v(" with you\n      ")], 1) : (_vm.ntype == 'vid_comment') ? _c('p', [_vm._v("\n        " + _vm._s(_vm.notification.user.name || _vm.notification.user.email) + " " + _vm._s(_vm.notification.text) + " "), _c('router-link', {
    attrs: {
      "to": '/videos/' + _vm.notification.video.id
    }
  }, [_vm._v("video")])], 1) : _c('p', [_vm._v(_vm._s(_vm.notification.text))])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-17526aad"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notification.vue
// module id = 990
// module chunks = 0